let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8j7ip")).then(() => parcelRequire('7Wq1Z'));